import { DeviceActionType } from '../../shared/constants';

export enum DeviceActionTypes {
  POPULATE_DEVICES = 'POPULATE_DEVICES',
  CLEAR_DEVICE_LIST = 'CLEAR_DEVICE_LIST',
  UPDATE_DEVICE_STATUS = 'UPDATE_DEVICE_STATUS',
  FAILURE_SYNC_DEVICE = 'FAILURE_SYNC_DEVICE',
  DID_SYNC_DEVICE = 'DID_SYNC_DEVICE',
  CLEAR_SYNC_DEVICE_STATE = 'CLEAR_SYNC_DEVICE_STATE',
  DEVICES_API_ERR = 'DEVICES_API_ERR',
  DEVICES_SET_LOAD_STATE = 'DEVICES_SET_LOAD_STATE',
  STORE_DEVICE_SHADOW = 'STORE_DEVICE_SHADOW',
  CLEAR_DEVICE_SHADOW = 'CLEAR_DEVICE_SHADOW',
  STORE_BB_IMAGES = 'STORE_BB_IMAGES',
  FETCH_DEVICE_BY_ID = 'FETCH_DEVICE_BY_ID',
  UPDATE_SELECTED_DEVICE_STATUS = 'UPDATE_SELECTED_DEVICE_STATUS',
  FETCH_DEVICE_NOTES = 'FETCH_DEVICE_NOTES',
  SET_NOTES_LOADING = 'SET_NOTES_LOADING',
  ADD_DEVICE_NOTE = 'ADD_DEVICE_NOTE',
  UPDATE_DEVICE_NOTE = 'UPDATE_DEVICE_NOTE',
  DELETE_DEVICE_NOTE = 'DELETE_DEVICE_NOTE',
  SET_NOTE_ACTION_STATUS = 'SET_NOTE_ACTION_STATUS',
  CLEAR_NOTE_ACTION_STATUS = 'CLEAR_NOTE_ACTION_STATUS',
  DEVICE_ACTION_SUCCESS = 'DEVICE_ACTION_SUCCESS',
  DEVICE_ACTION_FAILED = 'DEVICE_ACTION_FAILED',
  CLEAR_DEVICE_ACTION_STATUS = 'CLEAR_DEVICE_ACTION_STATUS',
  FETCH_DEVICE_HISTORY = 'FETCH_DEVICE_HISTORY',
  SET_HISTORY_LOADING = 'SET_HISTORY_LOADING',
  FETCH_DEVICE_FAULTS = 'FETCH_DEVICE_FAULTS',
  SET_FAULTS_LOADING = 'SET_FAULTS_LOADING',
  SET_FAULTS_DELETING = 'SET_FAULTS_DELETING',
}

export interface DeviceSyncPayload {
  sync_code: string;
  patient_customer_id: number;
}

export type DeviceStatus = 'offline' | 'online';

export interface Device {
  id: number;
  soc_id: number;
  serial_number: string;
  customer_id: number;
  first_name: string;
  last_name: string;
  email: string;
  date_of_birth: string;
  synced_by_customer_name?: string;
  sync_code_done_by?: number;
  sync_code_done_by_first_name?: string;
  sync_code_done_by_last_name?: string;
  facility_id: number | null;
  facility_name: string | null;
  hardware_version: string;
  software_version: string;
  software_channel_id: number;
  status: DeviceStatus;
  pinned_software_version_id: number;
  owner_name: string;
  software_version_freeze?: boolean;
  pinned_software_version_name?: string;
  created_at?: string;
  time_zone?: string;
  device_synced_at?: string;
  device_status?: string;
  last_seen_online?: string;
  contact_name?: string;
  contact_phone?: string;
  contact_email?: string;
  software_status?: string;
  facility_location?: string;
  model_number?: string;
  gender?: string;
  age?: string;
  phone?: string;
  facility_address?: string;
  facility_city?: string;
  facility_state?: string;
  facility_zip_code?: string;
  facility_country?: string;
  parent_facility_name?: string;
}

export interface ShadowConfig {
  configName: string;
  reportedValue: any;
  desiredValue: any;
}

interface BBImage {
  key: string;
  uploaded_at: string;
  presignedUrl: string;
}

export interface BBImageSetMetadata {
  serial_number: string;
  owner_id: number;
  med_event_id: string;
  sentry_event_id: string;
  uploaded_at: string;
  images: BBImage[];
}

export interface DeviceHistoryItem {
  issue_id: string;
  title: string;
  event_time: string;
  resolved_time: string;
}

export type PopulateDevicesAction = {
  type: DeviceActionTypes.POPULATE_DEVICES;
  payload: { deviceList: Device[] };
};

export type ClearDeviceList = {
  type: DeviceActionTypes.CLEAR_DEVICE_LIST;
};

export type UpdateDeviceStatusAction = {
  type: DeviceActionTypes.UPDATE_DEVICE_STATUS;
  payload: { deviceSerialNumber: string; deviceStatus: string };
};

export type SyncFailureDeviceAction = {
  type: DeviceActionTypes.FAILURE_SYNC_DEVICE;
  payload: { syncDeviceError: SyncDeviceError | null };
};

export type DidSyncDeviceAction = {
  type: DeviceActionTypes.DID_SYNC_DEVICE;
};

export type ClearSyncDeviceStatusAction = {
  type: DeviceActionTypes.CLEAR_SYNC_DEVICE_STATE;
};

export type DeviceAPIErrorAction = {
  type: DeviceActionTypes.DEVICES_API_ERR;
  payload: { error: any };
};

export type SetLoadStateAction = {
  type: DeviceActionTypes.DEVICES_SET_LOAD_STATE;
  payload: { isLoading: boolean };
};

export interface SyncDeviceError {
  error_code: 1001 | 1002;
  error_message: string;
}

export type StoreDeviceShadow = {
  type: DeviceActionTypes.STORE_DEVICE_SHADOW;
  payload: {
    deviceId: number;
    shadowConfigs: ShadowConfig[];
  };
};

export type ClearDeviceShadow = {
  type: DeviceActionTypes.CLEAR_DEVICE_SHADOW;
};

export type StoreBBImages = {
  type: DeviceActionTypes.STORE_BB_IMAGES;
  payload: {
    bbImages: BBImageSetMetadata[];
  };
};

export interface FetchDeviceByIdAction {
  type: DeviceActionTypes.FETCH_DEVICE_BY_ID;
  payload: { device: Device };
}

export type UpdateSelectedDeviceStatusType = {
  type: DeviceActionTypes.UPDATE_SELECTED_DEVICE_STATUS;
  payload: { status: string };
};

export interface FetchDeviceNotesAction {
  type: DeviceActionTypes.FETCH_DEVICE_NOTES;
  payload: { deviceNotes: DeviceNote[] };
}

export interface SetNotesLoadingAction {
  type: DeviceActionTypes.SET_NOTES_LOADING;
  payload: { isLoading: boolean };
}
export interface AddDeviceNoteAction {
  type: DeviceActionTypes.ADD_DEVICE_NOTE;
  payload: { deviceNote: DeviceNote };
}

export interface UpdateDeviceNoteAction {
  type: DeviceActionTypes.UPDATE_DEVICE_NOTE;
  payload: { deviceNote: DeviceNote };
}

export interface DeleteDeviceNoteAction {
  type: DeviceActionTypes.DELETE_DEVICE_NOTE;
  payload: { noteId: number };
}

export interface SetNoteActionStatus {
  type: DeviceActionTypes.SET_NOTE_ACTION_STATUS;
  payload: {
    success: boolean;
    message: string;
    show: boolean;
  };
}
export interface ClearNoteActionStatus {
  type: DeviceActionTypes.CLEAR_NOTE_ACTION_STATUS;
}
export interface DeviceActionStatusAction {
  type:
    | DeviceActionTypes.DEVICE_ACTION_SUCCESS
    | DeviceActionTypes.DEVICE_ACTION_FAILED;
  payload: {
    type: DeviceActionType;
  };
}
export interface ClearDeviceActionStatusAction {
  type: DeviceActionTypes.CLEAR_DEVICE_ACTION_STATUS;
}

export interface FetchDeviceHistoryAction {
  type: DeviceActionTypes.FETCH_DEVICE_HISTORY;
  payload: { history: DeviceHistoryItem[] };
}

export interface SetHistoryLoadingAction {
  type: DeviceActionTypes.SET_HISTORY_LOADING;
  payload: { isLoading: boolean };
}

export interface DeviceFault {
  fault_id: number;
  device_id: number;
  device_fault_code_id: number;
  fault_type: string;
  payload: {
    error_detail: string;
    error_id: number;
  };
  created_at: string;
  cleared_at: string | null;
  auto_cleared_at: string | null;
  cleared_by: string | null;
}

export interface FetchDeviceFaultsAction {
  type: DeviceActionTypes.FETCH_DEVICE_FAULTS;
  payload: { deviceFaults: DeviceFault[] };
}

export interface SetFaultsLoadingAction {
  type: DeviceActionTypes.SET_FAULTS_LOADING;
  payload: { isLoading: boolean };
}

export interface SetFaultsDeletingAction {
  type: DeviceActionTypes.SET_FAULTS_DELETING;
  payload: { isDeleting: boolean };
}

export interface DevicesStore {
  deviceList: Device[] | null;
  syncDeviceError: SyncDeviceError | null;
  error: any | null;
  isLoading: boolean;
  deviceSynced: boolean;
  shadowConfigs: ShadowConfig[] | null;
  shadowDeviceId: number | null;
  bbImages: BBImageSetMetadata[] | null;
  selectedDevice: Device | null;
  isNotesLoading: boolean;
  deviceNotes: DeviceNote[] | null;
  noteActionStatus: {
    success: boolean;
    message: string;
    show: boolean;
  };
  actionStatus: {
    type: DeviceActionType | null;
    success: boolean | null;
  };
  deviceHistory: DeviceHistoryItem[] | null;
  isHistoryLoading: boolean;
  deviceFaults: DeviceFault[] | null;
  isFaultsLoading: boolean;
  isFaultsDeleting: boolean;
}

export interface DeviceNote {
  note_id?: number;
  note: string;
  category: string;
  created_at: string;
  created_by?: string;
  issue_id?: string;
}

export type DeviceActions =
  | PopulateDevicesAction
  | ClearDeviceList
  | UpdateDeviceStatusAction
  | SyncFailureDeviceAction
  | DidSyncDeviceAction
  | ClearSyncDeviceStatusAction
  | DeviceAPIErrorAction
  | SetLoadStateAction
  | StoreDeviceShadow
  | ClearDeviceShadow
  | StoreBBImages
  | FetchDeviceByIdAction
  | UpdateSelectedDeviceStatusType
  | FetchDeviceNotesAction
  | SetNotesLoadingAction
  | AddDeviceNoteAction
  | UpdateDeviceNoteAction
  | DeleteDeviceNoteAction
  | SetNoteActionStatus
  | ClearNoteActionStatus
  | DeviceActionStatusAction
  | ClearDeviceActionStatusAction
  | FetchDeviceHistoryAction
  | SetHistoryLoadingAction
  | FetchDeviceFaultsAction
  | SetFaultsLoadingAction
  | SetFaultsDeletingAction;
